function calculatePercent(total: number, n: number, decimalFactor = 10) {
  return Math.round((100 * decimalFactor * n) / total) / decimalFactor + "%";
}

export default calculatePercent;
